import React from 'react'

/**
 * Renders markdown-like inline bold (**text**) and italic (_text_) as JSX.
 * Supports newlines — split and call per line.
 */
export function renderText(text) {
  if (!text) return null
  const parts = text.split(/(\*\*[^*]+\*\*)/g)
  return parts.map((part, i) => {
    if (part.startsWith('**') && part.endsWith('**')) {
      return <strong key={i}>{part.slice(2, -2)}</strong>
    }
    return <span key={i}>{part}</span>
  })
}
